import { createFileRoute } from '@tanstack/react-router';
import BioWeb from '../../-components/opcoes/bioweb/bioweb';

export const Route = createFileRoute(
  '/__authenticated/comercial/produto/clientes/hibridos/$id/bioweb',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { cliente } = Route.useRouteContext();

  return <BioWeb cliente={cliente} />;
}
